export const topInt = 2147483647;
export const bottomInt = -2147483648;

export const topChar = String.fromCharCode(65535);
export const bottomChar = String.fromCharCode(0);

export const topNumber = Number.POSITIVE_INFINITY;
export const bottomNumber = Number.NEGATIVE_INFINITY;
